<ng-container *transloco="let t; read: 'products'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      @if (('Permissions.Products.Create' | permission) && (createProducts == true)) {
        <div class="buttonContainer">
          <a class="addIcon" (click)="addHandler()">
            <span class="k-button-text">
              <span class="icon">
                <img src="../../../assets/icons/add-icon.svg">
              </span>
              <span>{{t('add')}}</span>
            </span>
          </a>
          <button
            kendoButton
            class="addIcon"
            (click)="showImportForm()"
            loadingIndication="/products/importProducts">
            <span class="k-button-text">
              <span class="icon">
                @if (vm.isLoading) {
                  <img src="../../../assets/icons/reload.svg" class="spinner">
                } @else {
                  <img src="../../../assets/icons/upload-icon.svg">
                }
              </span>
              <span>{{t('upload')}}</span>
              <span  class="tooltipContainer">
                <span [attr.tooltip]="t('tooltipUpload')" flow="right" class="tooltipContainer">
                  <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                </span>
              </span>
            </span>
          </button>
        </div>
      }
      @if (showUpload) {
        <form
          [formGroup]="importForm"
          (submit)="onUpload()"
          class="importForm">
          <label for="file-upload" id="file-upload-label" class="custom-file-upload">{{ t('chooseFile') }}</label>
          <input type="file" id="file-upload" (change)="onFileSelected($event)" />
            <button
              [disabled]="importForm.invalid"
              type="submit"
              class="buttonSecondary buttonUpload"
            >{{t('upload')}}
            </button>
          <a (click)="cancelUpload()" class="buttonSecondary">
            {{t('cancel')}}
          </a>
        </form>
      }
      <h2 class="margin-bottom-medium">{{t('searchTitle')}}</h2>
      <form
        [formGroup]="filterForm"
        (submit)="onSubmit(vm.searchRequest)"
        class="searchForm">
        <div class="searchInputContainer">
          <kendo-textbox
            formControlName="keyword" class="searchTextField">
          </kendo-textbox>
          @if (showReset) {
            <span (click)="onReset()" class="searchReset">
              <object type="image/svg+xml" data="http://localhost:4200/assets/icons/close-icon.svg" class="searchResetObject"></object>
            </span>
          }
        </div>
        <button
          [disabled]="filterForm.invalid || !filterForm.dirty"
          type="submit"
          kendoButton
          class="buttonPrimary"
          loadingIndication="/products/searchproducts"
        >{{t('filterSearch')}}</button>
      </form>
      <kendo-grid  #productGrid
        [rowClass]="rowClass"
        [data]="{data: vm.products, total: vm.total}"
        (edit)="editHandler($event)"
        (cancel)="cancelHandler($event)"
        (save)="saveHandler($event)"
        (add)="addHandler($event)"
        (remove)="removeHandler($event)"
        [skip]="vm.gridState.skip"
        [loading]="vm.isLoadingProducts"
        [pageSize]="vm.gridState.pageSize"
        [pageable]="true"
        (pageChange)="pageChangeSub$.next($event)"
        [resizable]="true">
        <kendo-grid-column field="name" [title]="t('productName')" media="(min-width: 993px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.name}}
            @if (!dataItem.isActive && dataItem.inactiveReason) {
              <span class="tooltipContainer">
                <span [attr.tooltip]="dataItem.inactiveReason" flow="right" class="tooltipContainer">
                  <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                </span>
              </span>
            }
          </ng-template>
          <ng-template
            kendoGridEditTemplate
            let-isNew="isNew"
            let-formGroup="formGroup">
            <kendo-textbox
              [formControl]="formGroup.get('name')"
            ></kendo-textbox>
            @if (formGroup.get('name').hasError('productNameExists')) {
              <kendo-formerror
              >{{t('productNameAlreadyExists')}}</kendo-formerror>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="internalNumber" [title]="t('procutInternalNumber')" media="(min-width: 993px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.internalNumber}}
          </ng-template>
          <ng-template
            kendoGridEditTemplate
            let-isNew="isNew"
            let-formGroup="formGroup"
            >
            <kendo-textbox
              [readonly]="isNew ? false : true"
              [formControl]="formGroup.get('internalNumber')"
              >
            </kendo-textbox>
            @if (formGroup.get('internalNumber').hasError('internalNumberExists')) {
              <kendo-formerror
              >{{t('productInternalNumberAlreadyExists')}}</kendo-formerror>
            }
          </ng-template>
        </kendo-grid-column>
        @if ((showActionCol == true)) {
          <kendo-grid-command-column
            [hidden]="!('Permissions.Products.Update' | permission) || !('Permissions.Products.Delete' | permission)"
            class="articleCommandCol"
            media="(min-width: 993px)"
            >
            <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
              <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
              <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
              <a [hidden]="isInEditing"
                (click)="toggleProductActive(dataItem)"
                [attr.tooltip]="dataItem.isActive ? t('deactivate') : t('activate')"
                flow="up"
                class="actionIcon toggle-active-btn">
                <img [src]="dataItem.isActive ? '../../../assets/icons/toggle-active.svg' : '../../../assets/icons/toggle-inactive.svg'">
              </a>
              <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                {{ isNew ? t('add') : t('save') }}
              </button>
              <button kendoGridCancelCommand>
                {{ isNew ? t('discard') : t('cancel') }}
              </button>
            </ng-template>
          </kendo-grid-command-column>
        }
        @if ((showOrderColumn == true)) {
          <kendo-grid-column
            [hidden]="!('Permissions.BasketItems.CreateGlobal' | permission) && !('Permissions.BasketItems.Create' | permission)"
            media="(min-width: 993px)">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-form>
              <kendo-numerictextbox
                [disabled]="isInEditing || !dataItem.isActive"
                [style.width.px]="80"
                [autoCorrect]="true"
                [min]="1"
                format="n0"
                [value]="1"
                #productQuantity>
              </kendo-numerictextbox>
              <button
                [disabled]="isInEditing || !dataItem.isActive || ((currentCompany?.tenantId == null) && isAdminView && (connectionState$ | async))"
                kendoButton
                loadingIndication="/basketitems/createbasketitem"
                (click)="addToCart(productQuantity.value, dataItem)"
                class="buttonPrimary addProductToCart"
              >{{t('addToCart')}}</button>
            </ng-template>
          </kendo-grid-column>
        }
        <!-- MOBILE GRID -->
        <kendo-grid-column-group media="(max-width: 992px)">
          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('productName')}}</h4>
              <span>{{dataItem.name}}</span>
              @if (!dataItem.isActive && dataItem.inactiveReason) {
                <span class="tooltipContainer">
                  <span [attr.tooltip]="dataItem.inactiveReason" flow="right" class="tooltipContainer">
                    <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                  </span>
                </span>
              }
            </ng-template>
            <ng-template
              kendoGridEditTemplate
              let-isNew="isNew"
              let-formGroup="formGroup">
              <h4 class="mobileGridHeader">{{t('productName')}}</h4>
              <kendo-formfield>
                <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
                @if (formGroup.get('name').hasError('productNameExists')) {
                  <kendo-formerror>
                    {{t('productNameAlreadyExists')}}
                  </kendo-formerror>
                }
              </kendo-formfield>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('procutInternalNumber')}}</h4>
              <span>{{dataItem.internalNumber}}</span>
            </ng-template>
            <ng-template
              kendoGridEditTemplate
              let-isNew="isNew"
              let-formGroup="formGroup"
              >
              <h4 class="mobileGridHeader">{{t('procutInternalNumber')}}</h4>
              <kendo-textbox
                [readonly]="isNew ? false : true"
                [formControl]="formGroup.get('internalNumber')"
                >
              </kendo-textbox>
              @if (formGroup.get('internalNumber').hasError('internalNumberExists')) {
                <kendo-formerror
                >{{t('productInternalNumberAlreadyExists')}}</kendo-formerror>
              }
            </ng-template>
          </kendo-grid-column>
          @if ((showActionCol == true)) {
            <kendo-grid-command-column
              [hidden]="!('Permissions.Products.Update' | permission) || !('Permissions.Products.Delete' | permission)"
              >
              <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
                <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
                <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
                <a [hidden]="isInEditing"
                  (click)="toggleProductActive(dataItem)"
                  [attr.tooltip]="dataItem.isActive ? t('deactivate') : t('activate')"
                  flow="up"
                  class="actionIcon toggle-active-btn">
                  <img [src]="dataItem.isActive ? '../../../assets/icons/toggle-active.svg' : '../../../assets/icons/toggle-inactive.svg'">
                </a>
                <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                  {{ isNew ? t('add') : t('save') }}
                </button>
                <button kendoGridCancelCommand>
                  {{ isNew ? t('discard') : t('cancel') }}
                </button>
              </ng-template>
            </kendo-grid-command-column>
          }
          @if ((showOrderColumn == true)) {
            <kendo-grid-column
              [hidden]="!('Permissions.BasketItems.CreateGlobal' | permission) && !('Permissions.BasketItems.Create' | permission)"
              >
              <ng-template
                kendoGridCellTemplate
                let-dataItem
                let-form>
                <kendo-numerictextbox
                  [disabled]="isInEditing || !dataItem.isActive"
                  [style.width.px]="80"
                  [autoCorrect]="true"
                  [min]="1"
                  format="n0"
                  [value]="1"
                  #productQuantity>
                </kendo-numerictextbox>
                <button
                  [disabled]="isInEditing || !dataItem.isActive || ((currentCompany?.tenantId == null) && isAdminView && (connectionState$ | async))"
                  kendoButton
                  (click)="addToCart(productQuantity.value, dataItem)"
                  class="buttonPrimary addProductToCartMobile"
                >{{t('addToCart')}}</button>
              </ng-template>
            </kendo-grid-column>
          }
        </kendo-grid-column-group>
        <!-- IF NO RESULTS COULD BE FOUND -->
        <ng-template kendoGridNoRecordsTemplate>
          <div class="text pl">{{ t("noResults") }}</div>
        </ng-template>
        <ng-template kendoGridLoadingTemplate>
          <div class="k-loading-color"></div>
          <div class="loading-container">
            <kendo-loader type="converging-spinner" size="large"></kendo-loader>
          </div>
        </ng-template>
        <!-- Paging -->
        <ng-template
          let-totalPages="totalPages"
          let-currentPage="currentPage"
          kendoPagerTemplate
          >
          <div class="width100 flex -spaceAround -alignCenter mts">
            <div class="flex padding-top-small">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons
                [buttonCount]="5"
              ></kendo-pager-numeric-buttons>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
            <div class="flex padding-top-small">
              <label class="label" for="pageBtnGroup"></label>
              <kendo-buttongroup
                [selection]="'single'"
                id="pageBtnGroup"
                class="-purple"
                >
                <button
                  (click)="
                    pageChangeSub$.next({
                      skip: vm.gridState.skip,
                      take: pageSizes.Small
                    })
                  "
                  kendoButton
                  [selected]="vm.gridState.pageSize === pageSizes.Small"
                  [toggleable]="true"
                  >
                  {{ pageSizes.Small }}
                </button>
                <button
                  (click)="
                    pageChangeSub$.next({
                      skip: vm.gridState.skip,
                      take: pageSizes.Medium
                    })
                    "
                  kendoButton
                  [selected]="vm.gridState.pageSize === pageSizes.Medium"
                  [toggleable]="true"
                  >
                  {{ pageSizes.Medium }}
                </button>
                <button
                  (click)="
                    pageChangeSub$.next({
                      skip: vm.gridState.skip,
                      take: pageSizes.Large
                    })
                  "
                  kendoButton
                  [selected]="vm.gridState.pageSize === pageSizes.Large"
                  [toggleable]="true"
                  >
                  {{ pageSizes.Large }}
                </button>
              </kendo-buttongroup>
            </div>
          </div>
        </ng-template>
      </kendo-grid>
      @if (deletionDialogOpened) {
        <kendo-dialog
          title="{{t('confirmDeletion')}}"
          (close)="deletionDialogClose('cancel')"
          [minWidth]="250"
          [width]="450">
          <p style="margin: 30px 0;">
            {{t('deletionMessage')}}
          </p>
          <kendo-dialog-actions>
            <button kendoButton (click)="deletionDialogClose('cancel')">{{ t('cancel') }}</button>
            <button kendoButton (click)="deletionDialogClose('delete')" themeColor="primary">{{ t('delete') }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
      @if (deactivateDialogOpened) {
        <kendo-dialog
          title="{{t('deactivate')}}"
          (close)="cancelDeactivation()"
          [minWidth]="250"
          [width]="450">
          <p style="margin: 30px 0;">
            {{t('deactivateMessage')}}
          </p>
          <kendo-formfield>
            <kendo-label [text]="t('inactiveReason')"></kendo-label>
            <kendo-textarea [(ngModel)]="inactiveReasonInput"></kendo-textarea>
          </kendo-formfield>
          <kendo-dialog-actions>
            <button kendoButton (click)="cancelDeactivation()">{{ t('cancel') }}</button>
            <button kendoButton (click)="confirmDeactivation()" themeColor="primary">{{ t('deactivate') }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
    }
  </ng-container>
</ng-container>